import { FC, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { userLoginSagas, tokenSelector, errorSelector } from 'ducks/user'
import { setError } from 'ducks/user/reducer'
import LoginForm from 'views/components/Forms/Login'
import Logo from 'views/components/UI/Logo'
import {
  LockBackdrop,
  LockCard,
  LockDescription,
  LockEyebrow,
  LockTitle,
} from './styled'

interface LoginCredentials {
  email: string
  password: string
}

interface SessionLockScreenProps {
  initialToken: string
  onUnlocked: () => void
}

const SessionLockScreen: FC<SessionLockScreenProps> = ({ initialToken, onUnlocked }) => {
  const dispatch = useDispatch()
  const token: string = useSelector(tokenSelector)
  const error: { message?: string } | boolean = useSelector(errorSelector)
  const initialTokenRef = useRef<string>(initialToken)
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false)

  useEffect(() => {
    dispatch(setError(false))
  }, [dispatch])

  useEffect(() => {
    if (hasSubmitted && token && token !== initialTokenRef.current) {
      onUnlocked()
    }
  }, [hasSubmitted, onUnlocked, token])

  const handleSubmit = (credentials: LoginCredentials): void => {
    setHasSubmitted(true)
    dispatch(
      userLoginSagas.run({
        email: credentials.email.toLowerCase(),
        password: credentials.password,
      }),
    )
  }

  const errorMessage: string = error && typeof error === 'object' ? error.message || '' : ''

  return (
    <LockBackdrop role="dialog" aria-modal="true" aria-label="Sesión bloqueada">
      <LockCard>
        <Logo width="210px" />
        <LockEyebrow>Protección por inactividad</LockEyebrow>
        <LockTitle>Sesión bloqueada</LockTitle>
        <LockDescription>
          La plataforma se ha bloqueado por inactividad. Introduce tus credenciales para continuar donde estabas.
        </LockDescription>
        <LoginForm onSubmit={handleSubmit} />
        {errorMessage && <LockDescription role="alert">{errorMessage}</LockDescription>}
      </LockCard>
    </LockBackdrop>
  )
}

export default SessionLockScreen
